import { LinkFieldProps, useFieldHelper, LinkField } from 'framework/ui/field';
import { useEntityUrl } from 'framework/routing';

type LeaveLinkProps = LinkFieldProps & {
  nameSource: string;
};

const useLeaveUrl = () => {
  return useEntityUrl({
    baseLink: '/leaves',
  });
};

const LeaveLink = ({ source, nameSource, ...props }: LeaveLinkProps) => {
  const { getValue } = useFieldHelper({ source });
  const { getValue: getName } = useFieldHelper({ source: nameSource });
  const { getSingleEntityUrl } = useLeaveUrl();
  const id = getValue();
  const name = getName();

  return <LinkField linkText={name || id} isInternal value={getSingleEntityUrl(id)} {...props} />;
};

export default LeaveLink;
